import {ItemProcesso} from "./lista-processo";

export class ListaDocumento {
  itens: ItemDocumento[];
}

export class ItemDocumento{
  dataCadastro: Date;
  processo: string;
  descricao: string;
  extensao: string;
  tipo: number;
  id: number;
  pastaId: number;
  pasta: string;
}
